import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLineupTemplate, setLineupType } from '../actions';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const lineUpTemplateDefault = '1-4-4-2';
const lineUpTemplates = ['1-5-4-1', '1-5-3-2', '1-4-4-2', '1-4-3-3', '1-3-4-3', '1-3-5-2', '1-4-5-1'];

const gridTemplateDefault = '3-3-3';
const gridTemplates = [
    { type: '3', name: '3x1' },
    { type: '3-3', name: '3x2' },
    { type: '3-3-3', name: '3x3' },
    { type: '4-4-4', name: '4x3' }
];

const typeSelectStyle = {
    marginRight: '10px'
};

class SelectLineUp extends Component {
    state = {
        type: localStorage.getItem('selectLineUpType') || 'lineup',
        value: this.props.lineupTemplate || localStorage.getItem('selectLineUpValue') || lineUpTemplates[0]
    };

    componentDidMount() {
        this.props.setLineupType(this.state.type);
        this.props.setLineupTemplate(this.state.value);
    }

    handleChangeType = (event, index, type) => {
        event.preventDefault();
        const value = type === 'lineup' ? lineUpTemplateDefault : gridTemplateDefault;

        this.setState({ type, value });

        this.props.setLineupType(type);
        this.props.setLineupTemplate(value);

        localStorage.setItem('selectLineUpType', type);
        localStorage.setItem('selectLineUpValue', value);
    };

    handleChange = (event, index, value) => {
        event.preventDefault();
        this.setState({ value });
        this.props.setLineupTemplate(value);
        localStorage.setItem('selectLineUpValue', value);
    };

    render() {
        const { type, value } = this.state;

        return (
            <div>
                <SelectField
                    floatingLabelText="Type Template"
                    value={type}
                    onChange={this.handleChangeType}
                    style={typeSelectStyle}
                >
                    <MenuItem value="lineup" primaryText="LineUp" />
                    <MenuItem value="grid" primaryText="Grid" />
                </SelectField>
                {type === 'lineup' && (
                    <SelectField floatingLabelText="LineUp Template" value={value} onChange={this.handleChange}>
                        {lineUpTemplates.map(template => (
                            <MenuItem key={template} value={template} primaryText={template.slice(2)} />
                        ))}
                    </SelectField>
                )}
                {type === 'grid' && (
                    <SelectField floatingLabelText="Grid Template" value={value} onChange={this.handleChange}>
                        {gridTemplates.map(template => (
                            <MenuItem key={template.name} value={template.type} primaryText={template.name} />
                        ))}
                    </SelectField>
                )}
            </div>
        );
    }
}

SelectLineUp.propTypes = {
    // From connect
    lineupType: PropTypes.string.isRequired,
    lineupTemplate: PropTypes.string.isRequired,
    setLineupTemplate: PropTypes.func.isRequired,
    setLineupType: PropTypes.func.isRequired
};

export default connect(
    ({ makerToolPage }) => ({
        lineupType: makerToolPage.lineupType,
        lineupTemplate: makerToolPage.lineupTemplate
    }),
    { setLineupTemplate, setLineupType }
)(SelectLineUp);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/SelectLineUp.js
 **/